import { useQuery } from "@tanstack/react-query";

import { getPatientInsurances } from "@/api";

export function usePatientInsurances(
  firstName: string,
  lastName: string,
  birthdate: string,
  enabled = true,
) {
  return useQuery({
    queryKey: [
      "insurance",
      "getPatientInsurances",
      firstName,
      lastName,
      birthdate,
    ],
    queryFn: () => getPatientInsurances(firstName, lastName, birthdate),
    enabled,
  });
}
